/**
 * Static template API — swap fetchTemplates() body later for real JSON API.
 * No legacy backend calls.
 */
import staticTemplates from '../data/staticTemplates.json';

function normalizeTemplate(raw) {
  const dimensions = typeof raw.dimensions === 'string'
    ? JSON.parse(raw.dimensions)
    : raw.dimensions;

  return {
    ...raw,
    dimensions: dimensions || { width: 720, height: 1000 },
    content: raw.content || {},
  };
}

/** @returns {Promise<object[]>} */
export async function fetchTemplates() {
  return staticTemplates.map(normalizeTemplate);
}

/** @returns {Promise<object|null>} */
export async function fetchTemplateById(id) {
  const templates = await fetchTemplates();
  const numericId = Number(id);
  return templates.find((t) => t.id === numericId || String(t.id) === String(id)) || null;
}
